__turbopack_context__.v({
  "inline-combobox-list-item": "InlineCombobox-module-scss-module__igOrpq__inline-combobox-list-item",
});
